/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Payment_Open_TermsInputs */

const en_reference_payment_open_terms = /** @type {(inputs: Reference_Payment_Open_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open terms`)
};

/**
* | output |
* | --- |
* | "Open terms" |
*
* @param {Reference_Payment_Open_TermsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_payment_open_terms = /** @type {((inputs?: Reference_Payment_Open_TermsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Payment_Open_TermsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_payment_open_terms(inputs)
});